import { useMemo, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Projects } from "../Data/Data";
import { delayNavigation} from "../helpers/helpers";

import Section from "../components/Section";
import { TiArrowSortedDown } from "react-icons/ti";
import { useDispatch } from "react-redux";
import VisualSearchPaths from "../components/VisualSearchPaths";

const VisualSearchBlock = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const [selectedProject, setSelectedProject] = useState(Projects[0]);
  // const [apartmentsList, setApartmentsList] = useState([]);
  /* const [fillters, setFillters] = useState({
    floors: [],
    types: [],
    sizes: [],
  }); */
  const [hoveredFloor, setHoveredFloor] = useState(null);

  const selectedProject = useMemo(() => {
    const projectName = location.pathname.split("/")[2];
    return Projects.find(
      (project) => project.name.toLowerCase() === projectName.toLowerCase()
    );
  }, [location.pathname]);
/*   const apartmentsList = useMemo(() => {
    if (!selectedProject) return [];

    return selectedProject.floors.flatMap((floor) => {
      if (
        fillters.floors.length > 0 &&
        !fillters.floors.includes(floor.floorNumber)
      ) {
        return [];
      }

      return floor.apartmens
        .map((apartment) => {
          const details = getApartmentTypeByIds(
            apartment.typeId,
            apartment.subTypeId,
            ApartmentsTypes,
            selectedProject
          );

          const typeMatch =
            fillters.types.length === 0 ||
            fillters.types.includes(apartment.typeId);

          const sizeMatch =
            fillters.sizes.length === 0 ||
            fillters.sizes.some(
              (size) =>
                details.apartmentSubTypeObject.size >= size.min &&
                details.apartmentSubTypeObject.size <= size.max
            );

          if (typeMatch && sizeMatch) {
            return {
              ...apartment,
              typeImg: details.apartmentTypeObject.img,
              size: details.apartmentSubTypeObject.size,
              typelabel: details.apartmentTypeObject.label,
              subTypelabel: details.apartmentSubTypeObject.label,
              floor: floor.floorNumber,
            };
          }

          return null;
        })
        .filter(Boolean);
    });
  }, [selectedProject, fillters]); */

  const floorIsSold = useMemo(() => {
    if (!selectedProject?.floors) return true;
    const floorApartmentsList = selectedProject.floors.find(
      (floor) => floor.floorNumber === hoveredFloor
    );
    // console.log("floorApartmentsList => ", floorApartmentsList);
    if (floorApartmentsList) {
      const apartmentsAreSold = floorApartmentsList.apartmens.findIndex(
        (apartment) => apartment.isSold === false
      );
      // console.log("apartmentsAreSold => ", apartmentsAreSold);
      if (apartmentsAreSold === -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }, [hoveredFloor, selectedProject.floors]);

  // console.log("floorIsSold => ", floorIsSold);

  // useEffect(() => {
  //   const projectName = location.pathname.split("/")[2];
  //   const projectObj = Projects.find(
  //     (project) => project.name.toLowerCase() === projectName.toLowerCase()
  //   );
  //   setSelectedProject(projectObj);

  //   const getFilteredApartments = (project, filters) => {
  //     return project.floors.flatMap((floor) => {
  //       if (
  //         filters.floors.length > 0 &&
  //         !filters.floors.includes(floor.floorNumber)
  //       ) {
  //         return [];
  //       }

  //       return floor.apartmens
  //         .map((apartment) => {
  //           const apartmentDetailsObject = getApartmentTypeByIds(
  //             apartment.typeId,
  //             apartment.subTypeId,
  //             ApartmentsTypes,
  //             selectedProject
  //           );
  //           const typeMatch =
  //             filters.types.length === 0 ||
  //             filters.types.includes(apartment.typeId);

  //           const sizeMatch =
  //             filters.sizes.length === 0 ||
  //             filters.sizes.some(
  //               (size) =>
  //                 apartmentDetailsObject.apartmentSubTypeObject.size >=
  //                   size.min &&
  //                 apartmentDetailsObject.apartmentSubTypeObject.size <= size.max
  //             );

  //           if (typeMatch && sizeMatch) {
  //             return {
  //               ...apartment,
  //               typeImg: apartmentDetailsObject.apartmentTypeObject.img,
  //               size: apartmentDetailsObject.apartmentSubTypeObject.size,
  //               typelabel: apartmentDetailsObject.apartmentTypeObject.label,
  //               subTypelabel:
  //                 apartmentDetailsObject.apartmentSubTypeObject.label,
  //               floor: floor.floorNumber,
  //             };
  //           }
  //           return null;
  //         })
  //         .filter(Boolean);
  //     });
  //   };

  //   const filteredApartments = getFilteredApartments(Projects[0], fillters);

  //   setApartmentsList(filteredApartments);
  // }, [location.pathname, fillters]);

  return (
    <Section bg={"bg-inherit"}>
      <h3 className="text-2xl xl:text-5xl font-gilroy uppercase tracking-widest text-primary-bg-blue col-start-2 mt-12 mb-4 xl:my-12">
        apartments
      </h3>
      <h5 className="text-base xl:hidden font-bold uppercase tracking-widest text-primary-bg-blue col-start-2 col-span-full mb-4">
        აირჩიეთ სართული
      </h5>
      <main className="col-span-10 col-start-2 xl:grid grid-cols-1 xl:grid-cols-12 max-h-fit mb-32 ">
        <>
          <ul className=" hidden xl:border-b-2 border-primary-dark/30 row-span-2 row-start-1 col-span-4 col-start-1 md:flex items-center justify-normal gap-4 list-none">
            {Projects.map((project) => {
              return (
                <li
                  key={project.id}
                  className={`text-lg tracking-wider  ${
                    selectedProject.id === project.id
                      ? "text-primary-bg-blue font-gilroy"
                      : "text-primary-bg-blue/30 hover:text-primary-bg-blue cursor-pointer transition-all duration-300 ease-linear font-gilroy font-extralight"
                  } py-4 flex items-center justify-center gap-2`}
                  onClick={() =>
                    delayNavigation(
                      dispatch,
                      navigate,
                      `/projects/${project.name}/${
                        location.pathname.includes("block")
                          ? "block"
                          : "apartments"
                      }`
                    )
                  }
                >
                  <span>{project.label}</span>
                  {selectedProject.id === project.id && (
                    <TiArrowSortedDown className="text-2xl" />
                  )}
                </li>
              );
            })}
          </ul>
        </>
        <div className=" hidden xl:border-b-2 xl:border-l-2 border-primary-dark/30 md:col-span-8 md:col-start-5 row-span-2 row-start-1 md:flex items-center justify-start gap-8 text-primary-bg-blue text-2xl xl:px-8">
          <Link
            className={`h-full flex items-center justify-center relative group cursor-pointer  ${
              location.pathname.includes("block") ? "font-bold" : ""
            } tracking-wider`}
            to={`${location.pathname.replace("apartments", "block")}`}
            onClick={(event) => {
              delayNavigation(
                dispatch,
                navigate,
                `${location.pathname.replace("apartments", "block")}`,
                event
              );
            }}
          >
            ვიზუალური სელექცია
            <span
              className={`absolute bottom-0 left-0 w-0 h-[2px] bg-primary-bg-blue transition-all duration-500 ${
                location.pathname.includes("block")
                  ? "w-full"
                  : "group-hover:w-full"
              } `}
            ></span>
          </Link>
          <Link
            className={`h-full flex items-center justify-center relative group cursor-pointer  ${
              location.pathname.includes("apartments") ? "font-bold" : ""
            } tracking-wider`}
            to={`${location.pathname.replace("block", "apartments")}`}
            onClick={(event) => {
              delayNavigation(
                dispatch,
                navigate,
                `${location.pathname.replace("block", "apartments")}`,
                event
              );
            }}
          >
            ფილტრით ძიება
            <span
              className={`absolute bottom-0 left-0 w-0 h-[2px] bg-primary-bg-blue transition-all duration-500 ${
                location.pathname.includes("apartments")
                  ? "w-full"
                  : "group-hover:w-full"
              } `}
            ></span>
          </Link>
        </div>
        <div className=" relative border-primary-dark/30 col-span-full row-span-10 row-start-3 flex flex-col items-center justify-center py-0 xl:px-0 mt-4 text-primary-bg-blue text-xl">
          <img
            // src={orangeFullCroped}
            src={selectedProject.floorSeatchImage}
            alt=""
            className="h-auto w-full object-fill transition-all animate-fadeIn"
          />
          <VisualSearchPaths
            project={selectedProject.name}
            floorIsSold={floorIsSold}
            hoveredFloor={hoveredFloor}
            setHoveredFloor={setHoveredFloor}
          />
          {hoveredFloor !== null && (
            <span
              className={`absolute z-50 left-14 bg-primary-bg-blue text-sm text-primary-light tracking-wider px-4 py-5 rounded-full flex flex-col items-center justify-center gap-2 transition-all animate-fadeIn05s`}
              style={{
                bottom: `calc(${
                  selectedProject.name === "greenhome"? 
                    hoveredFloor === 2 ? 40 : 40 + (hoveredFloor - 2) * 5 : 
                      hoveredFloor === 3 ? 30 : 30 + (hoveredFloor - 2) * 5
                }%)`,
              }}
            >
              Floor
              <br />
              {<span className="font-black text-5xl">{hoveredFloor}</span>}
            </span>
          )}
        </div>
      </main>
    </Section>
  );
};

export default VisualSearchBlock;
